import { render, staticRenderFns } from "./PTSchedules.vue?vue&type=template&id=6af6d6cb&"
import script from "./PTSchedules.vue?vue&type=script&lang=js&"
export * from "./PTSchedules.vue?vue&type=script&lang=js&"
import style0 from "./PTSchedules.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports